
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { ConfirmToContinueOptions } from "@/model/pagePartOptions/ConfirmToContinueOptions";
    import { VisitAnswer } from "@/model/VisitAnswer";

    @Component({})
    export default class ConfirmToContinuePart extends Vue {

        @Prop({ default: new ConfirmToContinueOptions() })
        options!: ConfirmToContinueOptions;

        @Prop({ required: true })
        answer!: VisitAnswer;

        @Prop({ default: false })
        isAdminView!: boolean;

        isChecked(): boolean {
            if(this.answer == null) return false;
            return ConfirmToContinueOptions.IsCorrect(this.answer.givenAnswer);
        }

        onCheckedChanged(isChecked: boolean) {
            this.$emit("answer-changed", -1, this.answer.pagePartID, isChecked ? "Confirmed" : "");
        }
    }
